import React, { useState } from 'react'
import { Container, Row, Col, Form, Button, Spinner } from 'react-bootstrap';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaCheckCircle } from "react-icons/fa";
import { useForm } from 'react-hook-form'


const Contacto = ({ id, refProp }) => {

    const [mensaje, setMensaje] = useState();
    const [cargando, setCargando] = useState(false);
    const { register, errors, handleSubmit } = useForm();

    const enviarFormulario = (data) => {
        setCargando(true)
        const url = 'https://hook.abstrahere.com/v1/sendmail/staticweb';

        fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'x-api-key': 'At6WuIg1dT8osNMidRNwU447KWsCpiFe15E6nCXs'
            }
        })
            .then((resp) => {
                if (resp.status === 200 && resp.ok) {
                    setMensaje(<>Mensaje enviado correctamente <FaCheckCircle /></>)
                } else {
                    throw Error(resp?.statusText);
                }
            })
            .catch(error => {
                console.log('error en la petición');
                console.log(error);
                setMensaje(<>No se pudo enviar el mensaje, vuelva a intentarlo más tarde</>)
            })
            .finally(() => {
                setCargando(false);
                setTimeout(() => {
                    setMensaje('')
                }, 40000);
            });

    }


    const onSubmit = (data, e) => {
        const enviar = {
            ...data,
            web: 'abstrahere.com'
        }
        enviarFormulario(enviar)
        e.target.reset();
    }

    return (
        <section className="page-section" ref={refProp} >
            <div className="name-section" id={id}>
                <Container>
                    <Row >
                        <Col lg={6} md={12} xs={12} className="pr-4">
                            <h1 className="letra-azul-claro font-weight-light">
                                ¿Te interesa alguno de nuestros productos?
                            </h1>
                            <h1 className="letra-azul">
                                ¡Contáctanos ahora!
                            </h1>
                            <hr className="divider-contacto" />
                            <div className="mb-4 pb-1">
                                Para más dudas, contáctanos a <a className="link-mail" href="mailto:contacto@abstrahere.com">contacto@abstrahere.com</a> y te responderemos a la brevedad para resolverlas.
                            </div>


                            <a className="rrss" href="https://www.facebook.com/abstraherechile/" target="_blank" rel="noreferrer"><FaFacebookF /><span >.</span></a>
                            <a className="rrss" href="https://twitter.com/abstraherechile" target="_blank" rel="noreferrer"><FaTwitter /><span >.</span></a>
                            <a className="rrss" href="https://www.linkedin.com/company/abstrahere-s-p-a" target="_blank" rel="noreferrer"><FaLinkedinIn /><span >.</span></a>

                        </Col>

                        <div className="separacion-md-menos" />
                        <div className="separacion-md-menos" />

                        <Col lg={6} md={12} className="form-contacto py-5 px-5">
                            <form className="my-2" onSubmit={handleSubmit(onSubmit)}>
                                <Row >
                                    <Col md={6} sm={12} className="mb-4">
                                        <Form.Control
                                            type="text"
                                            name="nombre"
                                            ref={register({
                                                required: {
                                                    value: true,
                                                    message: 'Nombre es requerido'
                                                }
                                            })}
                                            isInvalid={errors.nombre}
                                            placeholder="Nombre"
                                            className="incon" />
                                        <Form.Control.Feedback type="invalid" className="mensaje-validacion">
                                            {errors?.nombre?.message}
                                        </Form.Control.Feedback>
                                    </Col>
                                    <Col md={6} sm={12} className="mb-4">
                                        <Form.Control
                                            type="text"
                                            name="empresa"
                                            ref={register({
                                                required: {
                                                    value: true,
                                                    message: 'Empresa es requerida'
                                                }
                                            })}
                                            isInvalid={errors.empresa}
                                            placeholder="Empresa"
                                            className="incon" />
                                        <Form.Control.Feedback type="invalid" className="mensaje-validacion">
                                            {errors?.empresa?.message}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6} sm={12} className="mb-4">
                                        <Form.Control
                                            type="text"
                                            name="telefono"
                                            ref={register({
                                                required: {
                                                    value: true,
                                                    message: 'Teléfono es requerido'
                                                }
                                            })}
                                            isInvalid={errors.telefono}
                                            placeholder="Teléfono"
                                            className="incon" />
                                        <Form.Control.Feedback type="invalid" className="mensaje-validacion">
                                            {errors?.telefono?.message}
                                        </Form.Control.Feedback>
                                    </Col>
                                    <Col md={6} sm={12} className="mb-4">
                                        <Form.Control
                                            type="text"
                                            name="email"
                                            ref={register({
                                                required: {
                                                    value: true,
                                                    message: 'Email es requerido'
                                                },
                                                pattern: {
                                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                    message: "Email no válido"
                                                }
                                            })}
                                            isInvalid={errors.email}
                                            placeholder="Email"
                                            className="incon" />
                                        <Form.Control.Feedback type="invalid" className="mensaje-validacion">
                                            {errors?.email?.message}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="mb-4">
                                        <Form.Control
                                            as="textarea"
                                            rows="4"
                                            name="mensaje"
                                            ref={register({
                                                required: {
                                                    value: true,
                                                    message: 'Mensaje es requerido'
                                                }
                                            })}
                                            isInvalid={errors.mensaje}
                                            placeholder="Mensaje"
                                            className="incon" />
                                        <Form.Control.Feedback type="invalid" className="mensaje-validacion">
                                            {errors?.mensaje?.message}
                                        </Form.Control.Feedback>
                                    </Col>
                                </Row>
                                <div>
                                    <Button type="submit" size="lg" block className="btn-solucion no-bradius no-border"
                                        disabled={cargando}
                                    >
                                        {
                                            !cargando
                                                ? <>Enviar mensaje</>
                                                : <>
                                                    <Spinner
                                                        as="span"
                                                        animation="grow"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                        style={{ marginBottom: '2px' }}
                                                    /> Enviando...
                                                </>
                                        }
                                    </Button>
                                </div>

                                {!!mensaje &&
                                    <div className="mensaje-envio">
                                        {mensaje}
                                    </div>
                                }

                            </form>
                        </Col>


                    </Row>
                </Container>
            </div>
        </section>
    )
}

export default Contacto
